import { render, staticRenderFns } from "./FormConta.vue?vue&type=template&id=95c1c88c&scoped=true&"
import script from "./FormConta.vue?vue&type=script&lang=js&"
export * from "./FormConta.vue?vue&type=script&lang=js&"
import style0 from "./FormConta.vue?vue&type=style&index=0&id=95c1c88c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c1c88c",
  null
  
)

export default component.exports